import cn from 'classnames';
import styles from './RatingChooser.module.scss';
import { useState } from 'react';
import { Star } from '../Star';

type RatingChooserProps = {
  onChange: (count: number) => void;
  className?: string;
  value: number;
};

export function RatingChooser({
  onChange,
  className,
  value,
}: RatingChooserProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const [chosen, setChosen] = useState(value);
  const [starHoveredNumber, setStarHoveredNumber] = useState(0);

  const handleStarsChange = (count: number) => {
    setChosen(count);
    onChange(count);
  };

  const handleStarMouseEnter = (count: number) => {
    setStarHoveredNumber(count);
  };

  const handleStarMouseLeave = () => {
    setStarHoveredNumber(0);
  };

  return (
    <div className={wrapperClassName}>
      <Star
        number={1}
        onClick={() => handleStarsChange(1)}
        chosen={chosen}
        hoveredNumber={starHoveredNumber}
        onMouseEnter={() => handleStarMouseEnter(1)}
        onMouseLeave={handleStarMouseLeave}
      />
      <Star
        number={2}
        onClick={() => handleStarsChange(2)}
        chosen={chosen}
        hoveredNumber={starHoveredNumber}
        onMouseEnter={() => handleStarMouseEnter(2)}
        onMouseLeave={handleStarMouseLeave}
      />
      <Star
        number={3}
        onClick={() => handleStarsChange(3)}
        chosen={chosen}
        hoveredNumber={starHoveredNumber}
        onMouseEnter={() => handleStarMouseEnter(3)}
        onMouseLeave={handleStarMouseLeave}
      />
      <Star
        number={4}
        onClick={() => handleStarsChange(4)}
        chosen={chosen}
        hoveredNumber={starHoveredNumber}
        onMouseEnter={() => handleStarMouseEnter(4)}
        onMouseLeave={handleStarMouseLeave}
      />
      <Star
        number={5}
        onClick={() => handleStarsChange(5)}
        chosen={chosen}
        hoveredNumber={starHoveredNumber}
        onMouseEnter={() => handleStarMouseEnter(5)}
        onMouseLeave={handleStarMouseLeave}
      />
    </div>
  );
}
